import React, { useRef, useState, useEffect } from "react";
import Layout from "../component/Layout/Layout";
import { useNewHomeAPI } from "../hooks/useAllCategoryData";

const StoreGallery = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const openImagePopup = (index) => {
    setSelectedImageIndex(index);
  };
  const closeImagePopup = () => {
    setSelectedImageIndex(null);
  };
  useEffect(() => {
    const body = document.body;
    // const html = document.documentElement; // Selecting the html element
  
    if (selectedImageIndex !== null) {  // Ensure 0 is treated as a valid index
      body.classList.add("overflow-hidden");
      // html.classList.add("overflow-hidden");
    } else {
      body.classList.remove("overflow-hidden");
      // html.classList.remove("overflow-hidden");
    }
  
    // Cleanup to remove class when the component unmounts
    return () => {
      body.classList.remove("overflow-hidden");
      // html.classList.remove("overflow-hidden");
    };
  }, [selectedImageIndex]);

  


  const showPreviousImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? data.images.length - 1 : prevIndex - 1
    );
  };
  const showNextImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === data.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  /* const videoRef = useRef(null);

  const handlePlayVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }; */


  const [isOpen, setIsOpen] = useState(false);
  const videoRef = useRef(null); // Use a ref to access the video element

  // Function to open the modal
  const openModal = () => {
    setIsOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    if (videoRef.current) {
      videoRef.current.pause(); // Pause the video when the modal closes
      videoRef.current.currentTime = 0; // Optionally reset the video to the beginning
    }
    setIsOpen(false);
  };

  // useEffect to handle playing the video when the modal opens
  useEffect(() => {
    if (isOpen && videoRef.current) {
      videoRef.current.play(); // Play the video when the modal opens
    }
  }, [isOpen]); // Dependency on isOpen to trigger effect when modal state changes


  const { isLoading, error, data } = useNewHomeAPI();
  if (error) return <div>{error.message}</div>;


  return (
    <>
      <Layout title="Store | Chaashni by Maansi & Ketan">
        <div className="site-content-wrap static-page storegallery-page-wrap">
          <div className="container storegallery-top-fluid">
            <div className="row">
              {/* <div className="col-md-4">
              <video
                  onClick={handlePlayVideo}
                  ref={videoRef}
                  width="1024"
                  height="1920"
                  controls
                  autoPlay
                  playsInline
                  webkitPlaysInline
                  className="video-playing"
                  preload="auto"
                  poster="/images/showroom/poster-img.jpg"
                >
                  <source
                    src="/images/showroom/walkthrough.mp4"
                    type="video/mp4"
                  />
                </video>
              </div> */}
              <div className="col-md-12">
                <p>
                  Welcome to The Chaashni Experience Center, our flagship store
                  located in Naraina, New Delhi. Spread across an expansive
                  6,000 square feet, this curated space showcases nearly 500
                  designer outfits, bringing together couture and pret
                  collections under one roof.
                </p>
                <p>
                  We chose to open our store at our headquarters, away from
                  crowded markets, ensuring a calm, focused atmosphere for each
                  visitor. With an appointment-only system, we dedicate our time
                  and attention entirely to each client, providing them with a
                  personal stylist who guides them from start to finish.
                </p>
                <p>
                  Here, our guiding principle is simple: Wonderful Hospitality Always.
                </p>
                
                {/* <div className="video-btn-box">
                  <span className="btn-span" onClick={openModal}>Watch Video</span>
                </div> */}
                <p style={{textAlign: 'center'}}>Here’s a look inside the <strong>Chaashni Headquarters</strong> and <strong>Experience Center</strong>.</p>
              </div>
            </div>
          </div>



{data?.delhivideos && (
          <div className="container video-top-fluid">
            <div className="row justify-content-center"> 
              {data.delhivideos.map((src, index) => (            
              <div className="col-md-4" key={index}>
                <video
                  controls                 
                  playsInline
                  webkitPlaysInline
                  className="video-playing"
                  preload="auto"
                  poster={`${process.env.REACT_APP_IMAGE_URL}home/showroom/${src.poster}`}>
                  <source src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/${src.video}`} type="video/mp4" />
                </video>
                {/* <span>Behind the Seams</span> */}
              </div>))};                          
            </div>
          </div>
)}


          


          <div className="container-fluid storegallery-fluid">
          {data?.images && (
            <div className="row">
              {data.images.map((src, index) => (
                <div className="col-md-6 storegallery-box" key={index}>
                  <div className="storegallery">
                    <picture>
                      <source media="(min-width:650px)" srcSet={`${process.env.REACT_APP_IMAGE_URL}home/showroom/delhi/desktop/${src.desktop}`} />
                      <img 
                        src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/delhi/mobile/${src.mobile}`}
                        alt={`Thumbnail ${index + 1}`}
                        className="gallery-image" onClick={() => openImagePopup(index)}
                      />
                    </picture>
                  </div>
                </div>
              ))}
            </div> )}
          </div>
        </div>
      </Layout>
      {selectedImageIndex !== null && (
        <div className="image-popup">
          <div className="image-popup-overlay" onClick={closeImagePopup}></div>
          <span className="close" onClick={closeImagePopup}></span>
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/delhi/mobile/${data.images[selectedImageIndex].desktop}`}
            alt={`Image ${selectedImageIndex + 1}`}
            className="popup-image"
          />
          <button className="prev" onClick={showPreviousImage}></button>
          <button className="next" onClick={showNextImage}></button>
        </div>
      )}


      {isOpen && (
        <div className="video-modal">
          <div className="video-overlay" onClick={closeModal}> <span className="close"></span></div>
          <div className="video-modal-content">
          <span className="close mobile-video-close" onClick={closeModal}></span>
            {/* Video element with ref */}
            <video ref={videoRef} controls  width="1024"
                  height="1920"
                  autoPlay
                  playsInline
                  webkitPlaysInline
                  className="video-playing"
                  preload="auto"
                  poster={`${process.env.REACT_APP_IMAGE_URL}home/showroom/poster-img.jpg`}>
                  <source src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/walkthrough.mp4`} type="video/mp4" />
                  Your browser doesn't support HTML5 video. Please update or try a different browser.
            </video>
          </div>
        </div>
      )}
    </>
  );
};

export default StoreGallery;
